import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { WaitlistProvider } from './contexts/WaitlistContext';

function App() {
  return (
    <AuthProvider>
      <WaitlistProvider>
        <Routes />
      </WaitlistProvider>
    </AuthProvider>
  );
}

export default App;